import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-category-edit',
  template: `
    <div class="row">
      <div class="col-sm-12 offset-sm-0 col-lg-9 offset-lg-3 mt-5">
      <xng-breadcrumb ></xng-breadcrumb>
        <div class="row mb-4 mt-4">
          <div class="col-md-9">
            <h1>Actividades</h1>
            <p>Configura las actividades que están disponibles para los servicios técnicos.</p>
          </div>
          <div class="col-md-3 text-end mt-4">
            
          </div>
        </div>
        <div class="row">
          <div class="col-md-7">
            <div class="card border-0 rounded-4 shadow">
              <div class="card-body p-4">
                <div class="row">
                  <div class="col-md-12">
                    <h4>Agregar actividad</h4>
                    <p>Configura la actividad con los siguientes campos.</p>
                    <app-form-task-category (categoryData)="updateCategory($event)" [category]="category" [loading]="loading"></app-form-task-category>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class CategoryEditComponent implements OnInit {
  loading: boolean = false;
  category: any = null;

  constructor(
    private store: SettlementsService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private toastr: ToastrService,
    private breadcrumbService: BreadcrumbService,
  ) { }

  ngOnInit(): void {
    this.activateRoute.params.subscribe(params => {
      this.store.getTaskCategory(params['id']).subscribe({
        next: (res: any) => {
          this.loading = false;
          this.category = res;
        },
        error: (err: any) => {
          this.loading = false;
        }
      });
    });

    this.breadcrumbService.set('@index', 'Mantenimientos');
    this.breadcrumbService.set('@categories', 'Categoría de tareas');
    this.breadcrumbService.set('@categoryEdit', 'Editar categoría');
  }

  updateCategory(event: any) {
    this.store.updateTaskCategory(event.id, event).subscribe({
      next: (resp: any) => {
        this.loading = false;
        this.toastr.success('Se ha actualizado la categoría correctamente.', 'Categoría actualizada');
        this.router.navigateByUrl('/maintenances/categories');
      },
      error: (err: any) => {
        this.loading = false;
        this.toastr.error('No se ha podido actualizar la categoría.', 'Error');
      }
    });
  }
}
